



































































import { Component, Vue } from 'vue-property-decorator'
import PageHeader from '@/views/browse-and-go/components/PageHeader.vue'
import { plural } from '@/services/browse-and-go/labels'
import { bngState } from '@/services/browse-and-go/store'

@Component({
  name: 'BrowseAndGoOverview',
  components: { PageHeader }
})
export default class extends Vue {
  private plural = plural

  get urssafOperations() {
    return bngState.operations.filter(operation => operation.family === 'URSSAF')
  }

  get urssafCardCount() {
    const ids = new Set(this.urssafOperations.map(operation => operation.id))
    return bngState.cards.filter(card => ids.has(card.operationModelId)).length
  }

  private cardsOf(operationId: string) {
    return bngState.cards.filter(card => card.operationModelId === operationId).length
  }

  get foodCardCount() {
    return this.cardsOf('op-food')
  }

  get incentiveCardCount() {
    return this.cardsOf('op-incentive')
  }

  get defaultProgram() {
    return bngState.programs.find(program => program.isDefault) || null
  }

  private openOperation(id: string) {
    this.$router.push({ name: 'BrowseAndGoOther', hash: `#${id}` })
  }
}
